export const dataFetcher = () => {
  return new Promise((resolve, reject) => {
    resolve(new Array(6).fill(1));
  });
};
